import { useTrans } from '../../../../services/i18n'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import { Paper, SpacingContainer } from '../../../../components/common/Containers'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Checkbox from '@material-ui/core/Checkbox'
import Item from './Item'

const columns = [
  { key: 'select', align: 'left', width: 50 },
  { key: 'date', align: 'left' },
  { key: 'form-name', label: 'worksheet-name', align: 'left' },
  { key: 'admin-status', align: 'left' },
  { key: 'organization', align: 'left' },
  { key: 'assigned-to', align: 'left' },
  { key: 'score', align: 'left' },
  { key: '', align: 'left' }, // Actions column
]

export default function List({ items, selectedForms, onSelectForm, onSelectAll }) {
  const { trans } = useTrans()
  const allSelected = items.length > 0 && selectedForms.length === items.length
  const headerLabel = c => (c.key ? trans(c.label || c.key) : '')

  return (
    <TableContainer component={Paper} radius={9}>
      <SpacingContainer px="5sm3" py={2}>
        <Table style={{ minWidth: 1000 }}>
          <TableHead>
            <TableRow>
              {columns.map(c => (
                <TableCell key={c.key} align={c.align} width={c?.width}>
                  {c.key === 'select' ? (
                    <Checkbox
                      checked={allSelected}
                      indeterminate={selectedForms.length > 0 && selectedForms.length < items.length}
                      onChange={onSelectAll}
                    />
                  ) : (
                    headerLabel(c)
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map(form => (
              <Item
                form={form}
                columns={columns}
                key={form.id}
                selected={selectedForms.includes(form.id)}
                onSelect={onSelectForm}
              />
            ))}
          </TableBody>
        </Table>
      </SpacingContainer>
    </TableContainer>
  )
}
